// extracted by mini-css-extract-plugin
export default {"trips-list-pagination-error":"styles_trips-list-pagination-error__PDkcw"};